import React from 'react';
import { Grid } from '@mui/material';
import { PageContainer } from 'components';
import AssignedDelegationSingle from './Single/AssignedDelegation';
import { constBreadCrumbsTitle } from 'utility';
// TODO: Detail button is not responsive

// The most completed MaterialTable acroos the project (but with FilterPod component).
const AssignedDelegation = () => {
  const hint =
    'در این بخش می‌توانید لیست تمام وجه‌های تفویض شده خود به سایر کاربران را مشاهده و از هر یک گزارش تهیه نمایید. ';

  return (
    <PageContainer
      title="گزارش وجه‌های تفویض شده به سایرین"
      pageKey="assignedDelegation"
      description={hint}
      breadcrumbs={constBreadCrumbsTitle.DEFINE_DELEGATION_LIST}
    >
      <Grid item xs={12}>
        <AssignedDelegationSingle />
      </Grid>
    </PageContainer>
  );
};


export default AssignedDelegation;
